<!--<div class="enroll-eapp">-->
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="bottom-20"></div>
<div class="content">
    <div class="container">
        <div class="row">
            <div class="col-24">
                <h1>Electronic Application</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <p class="required">All fields are required, unless marked as optional.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 1: Tell us about the applicant</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Election Periods'"
                                               [options]="electionPeriods"
                                               [disabled]="disabled"
                                               [radioGroupName]="'ElectionPeriods'"
                                               [selectedValue]="enrollmentViewModel.ELECTION">
                        <!--(onValueChange)="electionPeriodChanged($event)"-->

                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="election-option"><label>Election Option</label> {{selectedOption}}</p>
            </div>
            <div class="row" *ngIf="isDateField">
                <div class="col-8">
                    <div class="bottom-20">
                        <ValidatedDateTextField *ngIf="isDateField"
                                                id="onDate"
                                                [date]="sepDate"
                                                [disabled]="disabled"
                                                [validators]="[validatedDate,notBlankValidator]">
                        </ValidatedDateTextField>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <ValidatedRadioButtonGroup [label]="''"
                                                   [options]="electionOprionsByPeriod"
                                                   [selectedValue]="reasonCode"
                                                   [radioGroupName]="'ElectionOptions'"
                                                   [disabled]="disabled">
                        </ValidatedRadioButtonGroup>
                    </div>
                </div>
            </div>
        </div>

        <!--End of Section 1-->
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 2: To Enroll in {{orgName}} Prescription Drug Plan</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="input-wrapper bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Desired Plan'"
                                               [options]="optionrbPlan"
                                               [selectedValue]="enrollmentViewModel.PLANTYPE"
                                               [disabled]="disabled"
                                               [radioGroupName]="'Plan'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-20">
                    <ValidatedTextField label="Application Received Date"
                                        [text]="enrollmentViewModel.APPDT"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-20">
                    <ValidatedTextField label="Effective Date of Enrollment"
                                        [text]="enrollmentViewModel.EFFDT"
                                        [disabled]="disabled">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 3: Beneficiary Information</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="bottom-20">

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Last Name"
                                                    [text]="enrollmentViewModel.APPLN"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Suffix (optional)"
                                                    [text]="enrollmentViewModel.SUFFIX"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="First Name"
                                                    [text]="enrollmentViewModel.APPFN"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="input-wrapper">
                                <ValidatedTextField label="MI (optional)"
                                                    [text]="enrollmentViewModel.APPMI"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="input-wrapper wide">
                                <ValidatedDropDown [label]="'Title (optional)'"
                                                   [options]="titleOptions"
                                                   [selectedValue]="enrollmentViewModel.TITLE"
                                                   [disabled]="disabled">
                                    <!--  (onValueChange)="updateInfo('title',$event)">-->
                                </ValidatedDropDown>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Medicare Number"
                                                    [text]="enrollmentViewModel.HICN" [maxlength]="20"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper bottom-20">
                                <ValidatedTextField label="Medicare Part A (Hospital) Effective date that appears on your Medicare Card (optional)"
                                                    [text]="enrollmentViewModel.MEDA"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper bottom-20">
                                <ValidatedTextField label="Medicare Part B (Medical) Effective date that appears on your Medicare Card (optional)"
                                                    [text]="enrollmentViewModel.MEDB"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField label="Date of Birth (MM/DD/YYYY)"
                                                    [text]="enrollmentViewModel.APPDOB"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="input-wrapper bottom-20">
                                <label>Gender</label>
                                <ValidatedRadioButtonGroup [label]="''"
                                                           [options]="genderOptions"
                                                           [selectedValue]="enrollmentViewModel.APPGEN"
                                                           [radioGroupName]="genderOptions"
                                                           [disabled]="disabled">
                                </ValidatedRadioButtonGroup>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Phone Number (numbers only) (optional)'"
                                                    id="phonenum"
                                                    [text]="enrollmentViewModel.APPPHONE"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Cell Phone Number (numbers only) (optional)'"
                                                    id="cellnum"
                                                    [text]="enrollmentViewModel.CELLPHONE"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="bottom-20">
                                <label>{{emailLabel}}</label>
                                <ValidatedTextField [text]="enrollmentViewModel.APPEMAIL" [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <!--<div class="row">
                    <div class="col-16">
                        <p><strong>Would you like to receive paperless Explanation of Benefit (EOB) statements?</strong></p>
                        <p>We'll send you a monthly email alert to view your statement. You can print it only if you need to - keep the clutter down and your information secure.</p>
                    </div>
                </div>-->
                    <div class="row">
                        <div class="col-16">
                            <p><strong>Paperless Settings</strong></p>
                        </div>
                        <div class="col-16">
                            <!--<p><strong>Get the benefit of paperless documents</strong></p>-->
                            <p>
                                Once your application is complete, would you like to receive Medicare Part D documents electronically? This lets you keep your documents organized in one secure online location that’s always accessible.
                            </p>
                            <div class="row">
                                <br />
                            </div>
                            <p>
                                The types of documents include evidence of coverage, your formulary, a pharmacy directory, explanation of benefit statements, plan coverage information, billing information and general plan information and messaging. You can go back to mailed versions at any time.
                            </p>

                        </div>

                    </div>

                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <!--<ValidatedRadioButtonGroup [label]="''"
                               [options]="eobOptions"
                               [selectedValue]="eobOption"
                               [radioGroupName]="'eobOptions'">

                            </ValidatedRadioButtonGroup>-->
                                <ValidatedCheckbox [id]="'EOBoption'"
                                                   [label]="'Yes, I want to go paperless for all available and future documents.'"
                                                   [checked]="PaperlessSelected"
                                                   [disabled]="disabled">
                                </ValidatedCheckbox>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <p>
                                    Once you enroll, or if you are already a returning member, you can go back to mailed versions at any time on <a class="link" href="https://www.caremark.com" target="_blank">Caremark.com</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="bottom-20">
                                <label>{{emailLabel}}</label>
                                <ValidatedTextField [text]="enrollmentViewModel.APPEMAIL"
                                                    [validators]="[]"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-16">
                            <div class="bottom-20">
                                <p>
                                    We will use your email address to keep you up to date on your SilverScript plan.
                                    You can opt out any time.
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--<div class="row">
                    <div class="col-16">
                        <div class="bottom-20">
                            <p>
                                The Explanation of Benefits (EOB) is a record of your prescription claims that have been processed for the month. The EOB statement shows each prescription’s cost,
                                the amount your plan has paid toward its cost, and the amount for which you’re responsible. You can change your preference on caremark.com at any time.
                            </p>
                            <p>
                                If you choose to receive paperless Explanation of Benefit statements, you will need to create an account on Caremark.com.
                                In addition to viewing your EOB statements online, Caremark.com will give you the ability to track your prescription costs and order mail service prescriptions.
                            </p>
                        </div>
                    </div>
                </div>-->
                    <div class="row">
                        <div class="col-16">
                            <label class="bottom-20">Permanent Address</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Line 1'"
                                                    id=""
                                                    [text]="enrollmentViewModel.APPADD1"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Line 2 (optional)'"
                                                    id=""
                                                    [text]="enrollmentViewModel.APPADD2"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'City'"
                                                    id=""
                                                    [text]="enrollmentViewModel.APPCITY"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="input-wrapper wide">
                                <ValidatedDropDown [label]="'State'"
                                                   [options]="allStates"
                                                   [selectedValue]="enrollmentViewModel.APPST"
                                                   [disabled]="disabled">
                                    <!--  (onValueChange)="updateInfo('title',$event)">-->
                                </ValidatedDropDown>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Zip'"
                                                    id=""
                                                    [text]="enrollmentViewModel.APPZIP"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24">
                            <div class="detail-info">
                                <input type="checkbox"
                                       class="option__input"
                                       id="same-as-address"
                                       [checked]="sameAsTopAddress"
                                       [disabled]="disabled" />
                                <label>Mailing Address is the same as Permanent Address</label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Line 1'"
                                                    id=""
                                                    [text]="enrollmentViewModel.MAILADD1"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Line 2 (optional)'"
                                                    id=""
                                                    [text]="enrollmentViewModel.MAILADD2"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'City'"
                                                    id=""
                                                    [text]="enrollmentViewModel.MAILCITY"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="input-wrapper wide">
                                <ValidatedDropDown [label]="'State'"
                                                   [options]="allStates"
                                                   [selectedValue]="enrollmentViewModel.MAILST"
                                                   [disabled]="disabled">
                                    <!--  (onValueChange)="updateInfo('title',$event)">-->
                                </ValidatedDropDown>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-wrapper">
                                <ValidatedTextField class=""
                                                    [label]="'Zip'"
                                                    id=""
                                                    [text]="enrollmentViewModel.MAILZIP"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 4: Paying Your Plan Premium</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p>
                    You can pay your monthly plan premium (including any late enrollment penalty you may owe) by automatic deduction from your monthly Social Security or Railroad Retirement Board benefit check, automatic bank draft withdrawal, credit card, or by mail.
                </p> <p>
                    <strong>  Please select a premium payment option.</strong> (If you don’t select an option, you will receive a monthly bill.)
                </p> <p>
                    <strong> Reminder,</strong> if you have secondary coverage that pays for part of your premiums (for example: from your employer or an SPAP) then you must choose monthly bills that you can pay by mail in order for the secondary coverage to be applied correctly.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="''"
                                               [options]="paymentOptions"
                                               [selectedValue]="enrollmentViewModel.PWO"
                                               (onValueChange)="enrollmentViewModel.PWO=$event"
                                               [radioGroupName]="'PaymentOptions'"
                                               [disabled]="disabled">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div *ngIf="enrollmentViewModel.PWO === 'Deduction from Social Security Check'">
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <p><strong>Please have your client acknowledge the following:</strong></p>
                        <p>
                            {{orgName}} will deduct your monthly premium from your Social Security check (or Railroad Retirement Board for those who qualify) automatically. Your request for Automatic Deduction will be submitted for the next available payment cycle. <b>Please Note:</b> This may take two or more months to begin once approved by Centers for Medicare and Medicaid Services, and will not cover any premiums for which we have already sent you an invoice, so please continue to pay your premium invoice as long as you receive it. Do not select this option if another entity (such as an Employer Group or State Pharmaceutical Assistance Program) is paying part of your premium. If Social Security/the Railroad Retirement Board does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="enrollmentViewModel.PWO === 'Deduction from Railroad Retirement Board'">
            <div class="row">
                <div class="col-16">
                    <div class="bottom-20">
                        <p><strong>Please have your client acknowledge the following:</strong></p>
                        <p>
                            {{orgName}} will deduct your monthly premium from your Social Security check (or Railroad Retirement Board for those who qualify) automatically. Your request for Automatic Deduction will be submitted for the next available payment cycle. <b>Please Note:</b> This may take two or more months to begin once approved by Centers for Medicare and Medicaid Services, and will not cover any premiums for which we have already sent you an invoice, so please continue to pay your premium invoice as long as you receive it. Do not select this option if another entity (such as an Employer Group or State Pharmaceutical Assistance Program) is paying part of your premium. If Social Security/the Railroad Retirement Board does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-24">
                <div id="payment-account-section"
                     *ngIf="enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal'">
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="field field--single"
                                                    [label]="'Name on Account: (alphanumeric characters only)'"
                                                    id="name-on-account"
                                                    [text]="enrollmentViewModel.ACCHOLDERNAME"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedRadioButtonGroup id="account-type"
                                                           label="Type of Account"
                                                           radioGroupName="account-type-radio-group"
                                                           [options]="accountTypeOptions"
                                                           [selectedValue]="enrollmentViewModel.EFTTYPE"
                                                           [disabled]="disabled">
                                </ValidatedRadioButtonGroup>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="field field--single"
                                                    [label]="'Financial Institution: (alphanumeric characters only)'"
                                                    id="financial-institution"
                                                    [text]="enrollmentViewModel.FININSTNAME"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="field field--single"
                                                    [label]="'Routing Number'"
                                                    id="routing-number"
                                                    [text]="enrollmentViewModel.ROUTINGNB"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <ValidatedTextField class="field field--single"
                                                    [label]="'Account Number'"
                                                    id="account-number"
                                                    [text]="enrollmentViewModel.ACCOUNTNB"
                                                    [disabled]="disabled">
                                </ValidatedTextField>
                            </div>
                        </div>
                    </div>
                    <div class="row indented-container gray-card gray-card__section">
                        <div class="col-24">
                            <div class="bottom-20">
                                <p><strong>Please have your client acknowledge the following:</strong></p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-24">
                            <p>
                                {{orgName}} will draw your premium from your bank account automatically. To sign up, please include a VOIDED check or savings account direct deposit from your bank with your enrollment form. <br />Your request for premium deduction will be submitted for the next available payment cycle. It may take one or more months for your deduction to begin. Please continue to pay your premium invoice as long as you receive it. If this request is received without a VOIDED check or Savings Account Direct Deposit form, your Automatic Bank Draft Withdrawal may not be processed. <br /><i>By selecting Automatic Bank Withdrawal, I authorize t   he bank or financial organization named above to pay my premium through electronic bank withdrawal payable to {{orgName}}. I authorize the deduction of up to $300 per month to settle my current balance due. The bank or other financial organization will be fully protected in honoring these payments until written notice from me canceling this request is received at the address listed at the end of this form.</i>
                            </p>

                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="enrollmentViewModel.PWO === 'Direct Bill'">
            <div class="row">
                <div class="col-16">
                    <p>You will be mailed a premium invoice each month. <strong> Do not send payment with this enrollment form.</strong></p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <div class="partition bottom-20">
                    <p class="bottom-20">
                        <strong>Note,</strong> the option to pay using a <strong>Credit Card</strong> can be
                        started after your
                        enrollment in the plan.     You can call us toll free once your enrollment in the plan is active, at:
                        <a class="tel-no" href="tel:+18668244055" nowrap>1-866-824-4055,</a> 24 hours a day, 7 days a week. TTY users call 711.
                    </p>
                    <p>
                        People with limited incomes may qualify for Extra Help to pay for their prescription
                        drug costs. If you
                        qualify, Medicare could pay for 75% or more of your drug costs including monthly prescription drug premiums,
                        annual deductibles and co-insurance. Additionally, those who qualify won’t have a coverage gap or a late
                        enrollment penalty.
                    </p>
                    <p>
                        Many people are eligible for these savings and don’t even know it. For more
                        information about this Extra
                        Help, contact your local Social Security office, or call Social Security at <a class="tel-no" href="tel:+18007721213">1-800-772-1213.</a> TTY users should
                        call <a class="tel-no" href="tel:+18003250778">1-800-325-0778.</a> You can also apply for Extra Help online at <strong>
                            <a target="_blank" href="https://www.ssa.gov/medicare/prescriptionhelp/">www.socialsecurity.gov/prescriptionhelp.</a>
                        </strong>
                        If you qualify for Extra Help with your Medicare prescription drug coverage costs, Medicare will pay all or
                        part of your plan premium. If Medicare pays only a portion of this premium, we will bill you for the amount
                        that Medicare does not cover.
                    </p>
                    <p>
                        <i>
                            If you are assessed a Part D-Income Related Monthly Adjustment Amount, you will be
                            notified by the Social
                            Security Administration. You will be responsible for paying this extra amount in addition to your plan
                            premium. You will either have the amount withheld from your Social Security or Railroad Retirement Board
                            benefit check or be billed directly by Medicare. Do NOT pay the Part D-IRMAA extra amount to {{orgName}}.
                        </i>
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 5: Please Read and Answer These Important Questions</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="bottom-10">
                    Some individuals may have other drug coverage, including other private insurance, TRICARE, Federal employee health benefits coverage, VA benefits, or State Pharmaceutical Assistance Programs.
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="input-wrapper bottom-10">
                    <label>Will you have other prescription drug coverage in addition to {{orgName}} Prescription Drug Plan?</label>
                    <ValidatedRadioButtonGroup [label]=""
                                               [options]="optionrbPresDrug"
                                               [selectedValue]="enrollmentViewModel.OTHCVRG"
                                               (onValueChange)="enrollmentViewModel.OTHCVRG=$event"
                                               [radioGroupName]="'Secondary-Coverage'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>
        <div *ngIf="enrollmentViewModel.OTHCVRG==='yes'">
            <fieldset>
                <legend>If “yes,” please list your other coverage and your identification (ID) number(s) for this coverage:</legend>

                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField [label]="'Name of other coverage'"
                                                [text]="enrollmentViewModel.OTHCVRGNAME"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField [label]="'ID# for this coverage (optional)'"
                                                [text]="enrollmentViewModel.OTHCVRGID"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField [label]="'Group # for this coverage (optional)'"
                                                [text]="enrollmentViewModel.OTHCVRGGRP"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField [label]="'RxBIN for this coverage (optional)'"
                                                [text]="enrollmentViewModel.COBBIN"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField [label]="'RxPCN for this coverage (optional)'"
                                                [text]="enrollmentViewModel.COBPCN"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField label="Effective Date for this coverage (optional)"
                                                [text]="enrollmentViewModel.COBEFFDT"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper bottom-10">
                            <ValidatedTextField label="Termination Date for this coverage (optional)"
                                                [text]="enrollmentViewModel.COBTERMDT"
                                                [disabled]="disabled">
                            </ValidatedTextField>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div class="row" *ngIf="visibleFrom2025">
            <div class="col-22">
                <div class="row">
                    <div class="col-22 bottom-10">
                        <!--<div class="input-wrapper ">-->
                        <ValidatedRadioButtonGroup [label]="'What is your Gender? Select one.'"
                                                   [options]="currentGenderOptions"
                                                   [radioGroupName]="'rCurrentGender'"
                                                   [selectedValue]="enrollmentViewModel.CURRENTGENDER"
                                                   [disabled]="disabled">
                        </ValidatedRadioButtonGroup>

                        <div class="col-7 otherbox">
                            <ValidatedTextField class="" [maxlength]="25" *ngIf="iscurrentGenderOther"
                                                [label]="'What is your gender? Select one.'"
                                                id="txtCurrentGender"                                                
                                                [text]="enrollmentViewModel.CURRENTGENDEROTH"
                                                [disabled]="disabled">

                            </ValidatedTextField>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-22  bottom-10">
                        <ValidatedRadioButtonGroup [label]="'Which of the following best represents how you think of yourself? Select one.'"
                                                   id="txtRepYourSelf"                                                   
                                                   [options]="repYourSelfOptions"
                                                   [radioGroupName]="'rRepYourSelf'"
                                                   [selectedValue]="enrollmentViewModel.GENDERNPRONOUN"
                                                   [disabled]="disabled">
                        </ValidatedRadioButtonGroup>

                        <!--<br />-->
                        <div class="col-7 otherbox">
                            <ValidatedTextField class="" [maxlength]="25" *ngIf="isyourSelfOther"
                                                [label]=""
                                                id="txtRepYourSelf"
                                                [text]="enrollmentViewModel.GENDERNPRONOUNOTH"
                                                [disabled]="disabled">

                            </ValidatedTextField>
                        </div>

                    </div>
                </div>
                <!--<genderPref [enrollmentgenderPrefyViewModel]="enrollmentViewModel"></genderPref>-->
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper bottom-10">
                    <ValidatedRadioButtonGroup [label]="'Applicant prefers to receive written communications in:'"
                                               [options]="optionrbLang"
                                               [selectedValue]="enrollmentViewModel.LANG"
                                               (onValueChange)="enrollmentViewModel.LANG =$event"
                                               [radioGroupName]="'Lang'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="input-wrapper bottom-10">
                    <ValidatedRadioButtonGroup [label]="'Select one if you want us to send you information in an accessible format:'"
                                               [options]="optionaccessibility"
                                               [selectedValue]="accessibilityValue"
                                               (onValueChange)="onAccessibilityChanges($event)"
                                               [radioGroupName]="'Langformat'">
                    </ValidatedRadioButtonGroup>
                </div>
            </div>
        </div>


        <!-- <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    If you need information in an alternate format, such as Braille, audio tape or large print, please contact {{orgName}} at <a class="tel-no" href="tel:+18665526106">1-866-552-6106,</a> 24 hours a day, 7 days a week. (TTY users call <a class="tel-no" href="tel:+18665526288">1-866-552-6288</a>).
                </p>
            </div>
        </div>
    </div>-->

        <div class="row">
            <div class="col-24">
                <h2 class="head2-small">Section 6: Please Read This Important Information</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="row">
                    <div class="col-16">
                        <p class="bold-font">
                            Please read:
                        </p>
                        <p>
                            <strong>If you are a member of a Medicare Advantage Plan</strong> (such as an HMO or
                            PPO), you may already have prescription drug coverage from your Medicare Advantage
                            Plan that will meet your needs. By joining {{orgName}}, your membership in your Medicare Advantage Plan may end. This will affect both
                            your doctor and hospital coverage as well as your prescription drug coverage. Read
                            the information that your Medicare Advantage Plan sends you and if you have questions,
                            contact your Medicare Advantage Plan.
                        </p>
                        <p>
                            <strong>
                                If you currently have health coverage from an employer or union, joining
                                {{orgName}} PDP could affect your employer or union health benefits.
                            </strong> You could lose
                            your employer or union health coverage if you join {{orgName}} PDP.
                            Read the communications your employer or union sends you. If you have questions,
                            visit their website, or contact the office listed in their communications. If there
                            isn’t information on whom to contact, your benefits administrator or the office
                            that answers questions about your coverage can help.
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-16">
                        <label>Notes (max 300 characters) (optional)</label>
                        <textarea rows="3" cols="60" name="txtNotes" maxlength="300" [disabled]="disabled"
                                  [(ngModel)]="enrollmentViewModel.NOTES"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <!--check below-->
                <button id="continueEAP" class="button primary" (click)="continueStep()">Everything looks good, continue</button>
                <button id="continueEAP" class="button primary" (click)="correctionStep()">Something is wrong. Please inform my agent that a correction is needed.</button>
                <button id="continueEAP" class="button primary" (click)="rejectStep()">I've changed my mind. Reject and cancel this application process.</button>
            </div>
        </div>
    </div>
</div>

